__turbopack_context__.v({
  "iframe": "_2uHK0W_iframe",
  "player": "_2uHK0W_player",
  "rounded": "_2uHK0W_rounded",
});
